import React from "react";
import { motion } from "framer-motion";
import {
  Award, Users, Target, Layers, ClipboardCheck, Scale, MapPin, BookOpen,
} from "lucide-react";
import { DIFFERENTIATORS } from "../../data/hseData";

const ICONS = { Award, Users, Target, Layers, ClipboardCheck, Scale, MapPin, BookOpen };

export const Differentiators = () => {
  return (
    <section id="diferenciais" data-testid="section-diferenciais" className="relative py-24 sm:py-32 bg-[#0B1B2D]">
      <div className="absolute inset-0 bg-grid opacity-30 pointer-events-none" />
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 relative">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-3 mb-6">
            <span className="w-8 h-px bg-[#2FA36B]" />
            <span className="font-condensed uppercase text-xs tracking-[0.4em] text-[#2FA36B] font-bold">
              Diferenciais
            </span>
            <span className="w-8 h-px bg-[#2FA36B]" />
          </div>
          <h2 className="font-condensed font-bold uppercase text-4xl sm:text-5xl lg:text-6xl text-white leading-[0.95] tracking-tight max-w-3xl mx-auto">
            Por que escolher
            <span className="text-[#2FA36B]"> a HSE?</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/[0.07] border border-white/[0.07]">
          {DIFFERENTIATORS.map((d, i) => {
            const Icon = ICONS[d.icon] || Award;
            return (
              <motion.div
                key={d.title}
                data-testid={`diff-card-${i}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: (i % 4) * 0.08 }}
                className="bg-[#12283F] hover:bg-[#173250] transition-colors p-6 sm:p-8 group"
              >
                <Icon size={28} strokeWidth={1.75} className="text-[#2FA36B] mb-5" />
                <h3 className="font-condensed font-bold uppercase text-base sm:text-lg text-white tracking-tight leading-tight mb-3">
                  {d.title}
                </h3>
                <p className="font-body text-sm text-white/60 leading-relaxed">
                  {d.text}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Differentiators;
